/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M12 22c1.1046 0 2-.895 2-2 0-1.104-.8954-2-2-2s-2 .896-2 2c0 1.105.8954 2 2 2M12 6c1.1046 0 2-.895 2-2 0-1.104-.8954-2-2-2s-2 .896-2 2c0 1.105.8954 2 2 2M20 14c1.1046 0 2-.895 2-2 0-1.104-.8954-2-2-2s-2 .896-2 2c0 1.105.8954 2 2 2M4 14c1.1046 0 2-.895 2-2 0-1.104-.8954-2-2-2s-2 .896-2 2c0 1.105.8954 2 2 2M6 12h12M10.586 5.415l-5.172 5.172M18.586 13.415l-5.172 5.172"
  />,
  'Network'
);
